//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import isEmpty from "lodash.isempty";
import isEqual from "lodash.isequal";
import React, { createContext, useEffect, useMemo, useState } from "react";
import { capFirstLetter, chunkArray, shuffle } from "../../utils/functions";
import { loadDataFromSessionStorage, saveToStorage } from "../../utils/hooks";
import {
  getClassCategory,
  orderClassCategories,
  splitClasses,
  transformSplit,
} from "./business-logic/request-splitter";
import { getSubjectFromExpectation } from "./business-logic/subject-determinant";

const defaultFilters = {
  gender: ["male", "female"],
  sortBy: "Recommended",
  showPremium: false,
  lessonType: "physical",
  minPrice: 0,
  maxPrice: 0,
  educationDegrees: [],
  educationCountries: [],
  educationGrades: [],
  maxAge: 0,
  minExperience: "",
};

const emptyRequest = {
  contactDetails: {
    customerType: "",
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    vicinity: "",
    region: "",
    state: "",
    country: "",
    medium: "",
  },
  lessonDetails: {
    lessonType: "physical",
    lessonSchedule: {
      lessonDuration: "",
      lessonHours: "",
      lessonDays: [],
      lessonTime: "",
      lessonUrgency: "",
    },
  },
  subjectDetails: {},
  filters: defaultFilters,
  childDetails: [],
  splitRequests: [],
};

const addLessonTypeToFilter = (requestInput) => {
  let lessonType = requestInput.lessonDetails.lessonType;
  requestInput.filters.lessonType = lessonType;
  return requestInput;
};

const RequestDataContext = createContext({});
export function isOneTeacher(childDetails = []) {
  let teacherSplitOptions = transformSplit(childDetails);
  return Object.keys(teacherSplitOptions).length === 1;
}

const RequestDataProvider: React.FC<any> = ({ initialValue, children }) => {
  let defaultValue = { ...emptyRequest, ...initialValue };
  let requestValue = addLessonTypeToFilter(defaultValue);
  let [requestData, setRequestData] = useState(requestValue);
  useEffect(() => {
    if (initialValue && Object.keys(initialValue).length > 0) {
      setRequestData(defaultValue);
    }
  }, [initialValue]);

  let {
    splitRequests,
    childDetails,
    subjectDetails,
    contactDetails,
    lessonDetails,
    filters,
  } = requestData;

  //TODO: Rewrite useCurrency to (1): have the currency on the tutor's account as the initial input
  // (2) Instead of saving the "currencies" we now support, we just save the countries instead
  // (3) Conversion rates should not be based on "currency", but on country

  let country = contactDetails && contactDetails.country;
  let state = contactDetails && contactDetails.state;
  let subjectDetailName = subjectDetails && subjectDetails.name;

  const childContext = useMemo(() => {
    let teacherSplitOptions = transformSplit(childDetails);
    let initialTeacherOption =
      splitRequests.length > 0 ? splitRequests[0].teacherOption : "";

    let teacherOptions = Object.keys(teacherSplitOptions);
    let isOneTeacherOption = teacherOptions.length === 1;

    /**
     * Generates a new request split that includes the search subject for each
     * split based on the expectations typed by the user.
     * @param {Array[Objects]} splitArray
     * @returns {Array}
     */
    const generateSearchSubject = (splitArray) => {
      let splitWithSeachSubject = splitArray.map((split) => {
        let expectations = childDetails
          .filter(({ firstName }) => split.names.includes(firstName))
          .map((split) => split.expectation);

        let searchSubject = getSubjectFromExpectation(
          expectations.toString(),
          split.subjectGroup,
        );

        return { ...split, searchSubject };
      });

      return splitWithSeachSubject;
    };
    /**
     * Updates childDetails in Request Data
     * @param {Array} childDetails
     */
    const onUpdateChildDetail = (childDetails) => {
      let newRequestData = { ...requestData, childDetails };
      let _teacherSplitOptions = transformSplit(childDetails);
      let splitValue = Object.values(_teacherSplitOptions)[0];
      let finalValue = generateSearchSubject(splitValue);
      newRequestData.splitRequests = finalValue;
      setRequestData(newRequestData);

      // return newRequestData;
    };

    /**
     * Updates splitRequests in Request Data
     * @param {Array} splitRequests
     */
    const onUpdateRequestSplit = (splitRequests) => {
      let newRequestData = { ...requestData, splitRequests };
      setRequestData(newRequestData);
      // return newRequestData;
    };

    function onUpdateContactDetails(contactDetails, _subjectDetails) {
      let newRequestData = { ...requestData, contactDetails };
      if (_subjectDetails) {
        newRequestData = { ...newRequestData, subjectDetails: _subjectDetails };
      }
      setRequestData(newRequestData);
      // return newRequestData;
    }

    /**
     * Updates lesson schedule in Request Data
     * @param {Object} newSchedule
     * @param {Array[String]} daysSelected
     */
    const onUpdateSchedule = (newSchedule, daysSelected) => {
      /**
       * Capitalizes the first letter of each weekday in the lesson schedule
       */
      function capitalizeLessonDays() {
        let lessonDays = newSchedule.lessonDays.map((day) =>
          capFirstLetter(day),
        );
        let schedule = { ...newSchedule, lessonDays };

        let selectedDays = daysSelected.map((day) => capFirstLetter(day));
        return { schedule, selectedDays };
      }

      function getSubjectsAndClass() {
        let totalSubjects = [];
        splitRequests.forEach(({ subjectGroup }) =>
          totalSubjects.push(...subjectGroup),
        );

        let studentClasses = [];
        splitRequests.forEach((split) =>
          split.class.forEach((item) => studentClasses.push(item)),
        );

        let classCategories = studentClasses.map((studentClass) =>
          getClassCategory(studentClass),
        );
        classCategories = orderClassCategories([...new Set(classCategories)]);

        return { totalSubjects, studentClasses, classCategories };
      }

      let { schedule, selectedDays } = capitalizeLessonDays();

      let { totalSubjects, studentClasses, classCategories } =
        getSubjectsAndClass();

      /**
       * Generates a new "splitRequest" array that includes the number of days of lessons
       * each split or teacher is assigned per week based on if the user selected to have
       * One Teacher, Separate Teachers or Specialized Teachers.
       *
       */
      function generateLessonsForSplit() {
        let newRequestSplit = [];

        let isPrimaryAndJSSOnly = isEqual(classCategories, ["Primary", "JSS"]);
        let { secondaryClasses, remainingClasses } =
          splitClasses(studentClasses);

        let teacherOption =
          splitRequests.length > 0 && splitRequests[0].teacherOption;
        let isSeparateOrOneTeacher =
          teacherOption === "One teacher" ||
          teacherOption === "Separate teachers";

        if (isSeparateOrOneTeacher || secondaryClasses.length === 0) {
          newRequestSplit = splitRequests.map((split) => ({
            ...split,
            lessonDays: selectedDays,
          }));
        } else if (isPrimaryAndJSSOnly) {
          newRequestSplit = splitDaysBySubjects(splitRequests, totalSubjects);
        } else if (secondaryClasses.length > 0 && remainingClasses.length > 0) {
          let secondarySplit = splitRequests.filter((split) =>
            split.class.every((studentClass) =>
              secondaryClasses.includes(studentClass),
            ),
          );
          let secondarySubjects = [];
          secondarySplit.forEach(({ subjectGroup }) =>
            secondarySubjects.push(...subjectGroup),
          );

          let remainingSplit = splitRequests.filter((split) =>
            split.class.every((studentClass) =>
              remainingClasses.includes(studentClass),
            ),
          );

          let _remainingSplit = remainingSplit.map((split) => ({
            ...split,
            lessonDays: schedule.lessonDays,
          }));

          let _secondarySplit = splitDaysBySubjects(
            secondarySplit,
            secondarySubjects,
          );

          newRequestSplit = [..._remainingSplit, ..._secondarySplit];
        } else {
          newRequestSplit = splitDaysBySubjects(splitRequests, totalSubjects);
        }

        return newRequestSplit;
      }

      /**
       * Generates a new 'splitRequest' that uses the number of subjects each teacher
       * is assigned to determine the proportion of the the total days selected will be
       * assigned to each teacher.
       * @param {Array[Object]} requestSplit Array of each request split
       * @param {Array[String]} subjects All subjects requested for the whole request
       * @returns {Array[Object]}
       */
      function splitDaysBySubjects(requestSplit, subjects) {
        let newRequestSplit = [];
        let numberOfTeachers = requestSplit.length;

        shuffle(selectedDays);

        let daysIsMultipleOfTeachers =
          selectedDays.length % numberOfTeachers === 0;
        let averageDaysPerTeacher = selectedDays.length / numberOfTeachers;
        let maximumDays = Math.round(averageDaysPerTeacher);
        let subjectsPerGroup = requestSplit.map(
          ({ subjectGroup }) => subjectGroup.length,
        );

        const hasEqualNumberOfSubjects =
          [...new Set(subjectsPerGroup)].length === 1;

        if (daysIsMultipleOfTeachers || hasEqualNumberOfSubjects) {
          let lessonDaysPerTeacher = chunkArray(selectedDays, maximumDays);

          newRequestSplit = requestSplit.map((split, index) => ({
            ...split,
            lessonDays: lessonDaysPerTeacher[index],
          }));
        } else {
          let daysPerTeacher = requestSplit.map((split) =>
            getDaysPerTeacher(split, subjects),
          );

          newRequestSplit = requestSplit.map((split, index) => ({
            ...split,
            lessonDays: selectedDays.splice(0, daysPerTeacher[index]),
          }));
        }
        return newRequestSplit;
      }

      function getDaysPerTeacher(split, subjects) {
        let numberOfDays =
          (split.subjectGroup.length / subjects.length) * selectedDays.length;

        numberOfDays =
          Math.round(numberOfDays) > 0 ? Math.round(numberOfDays) : 1;

        return numberOfDays;
      }

      let newRequestSplit = generateLessonsForSplit();
      let newLessonSchedule = { ...lessonDetails.lessonSchedule, ...schedule };
      let newFilters = { ...filters, budget: "" };

      let newLessonDetails = {
        ...lessonDetails,
        lessonSchedule: newLessonSchedule,
      };

      let newRequestData = {
        ...requestData,
        filters: newFilters,
        lessonDetails: newLessonDetails,
        splitRequests: newRequestSplit,
      };
      setRequestData(newRequestData);
      return newRequestData;
    };

    /**
     * Updates the change in selected students in Request Data
     * @param {Array[String]} unselectedStudents
     */
    const onUpdateStudents = (unselectedStudents) => {
      let newRequestSplit = [];
      let studentsInRequest = childDetails.map(({ firstName }) => firstName);
      let selectedStudents =
        unselectedStudents.length > 0
          ? studentsInRequest.filter(
              (student) => !unselectedStudents.includes(student),
            )
          : studentsInRequest;

      newRequestSplit = splitRequests.map((split) => {
        let prevStudentsRemoved = split.removedStudents
          ? split.removedStudents
          : [];
        let newSplit = { ...split, removedStudents: prevStudentsRemoved };

        if (unselectedStudents.length > 0) {
          let studentsInSplit = unselectedStudents.filter((student) =>
            split.names.includes(student),
          );

          //This part handles removing students
          if (studentsInSplit.length > 0) {
            let studentsRemovedFromSplit = unselectedStudents.filter(
              (student) => newSplit.removedStudents.includes(student),
            );

            let studentsToRemoveFromSplit = studentsInSplit.filter(
              (student) => !studentsRemovedFromSplit.includes(student),
            );

            //Remove students from "name" in split and add them to "removedStudents"
            studentsToRemoveFromSplit.forEach((student) => {
              let index = newSplit.names.indexOf(student);
              newSplit.names.splice(index, 1);
              newSplit.removedStudents.splice(0, 0, student);
            });
          }
        }

        //This part handles adding students back

        if (selectedStudents.length > 0) {
          let studentsNotInSplit = selectedStudents.filter(
            (student) => !newSplit.names.includes(student),
          );
          if (studentsNotInSplit.length > 0) {
            let studentsToBeAddedToSplit = studentsNotInSplit.filter(
              (student) => newSplit.removedStudents.includes(student),
            );

            //Remove students from "removedStudents" in split and add them to "name"
            studentsToBeAddedToSplit.forEach((student) => {
              let index = newSplit.removedStudents.indexOf(student);
              newSplit.removedStudents.splice(index, 1);
              newSplit.names.splice(0, 0, student);
            });
          }
        }

        return newSplit;
      });

      let newRequestData = { ...requestData, splitRequests: newRequestSplit };

      setRequestData(newRequestData);
    };

    /**
     * Defines the condition for each path along the request flow
     * @param {String} path
     */
    const checkPathAccess = (path) => {
      let conditions = {
        "/about-child": () => contactDetails.state || contactDetails.country,
        "teacher-options": () =>
          childDetails.length > 0 || Boolean(subjectDetails.name),
        "/lesson-schedule": () => splitRequests.length > 0,
        search: () => !isEmpty(lessonDetails.lessonSchedule),
      };
      let item = Object.keys(conditions).find((x) => path.includes(x));
      if (item) {
        let logicFunction = conditions[item];
        return logicFunction();
      }
      return true;
    };
    return {
      generateSearchSubject,
      onUpdateContactDetails,
      onUpdateChildDetail,
      onUpdateRequestSplit,
      onUpdateStudents,
      onUpdateSchedule,
      checkPathAccess,
      teacherSplitOptions,
      initialTeacherOption,
      isOneTeacherOption,
      requestData,
      setRequestData,
    };
  }, [
    childDetails,
    country,
    state,
    filters,
    lessonDetails,
    requestData,
    splitRequests,
    subjectDetailName,
  ]);

  return (
    <RequestDataContext.Provider value={childContext}>
      {children}
    </RequestDataContext.Provider>
  );
};
const useRequestContext = (sessionID) => {
  let {
    requestData: sourceRequestData,
    setRequestData: oldSetRequestData,
    ...rest
  }: any = React.useContext(RequestDataContext);
  let [_session_id, requestData] = loadDataFromSessionStorage(sessionID, "all");
  if (!requestData || Object.keys(requestData).length === 0) {
    requestData = sourceRequestData;
  }
  function setRequestData(dd) {
    oldSetRequestData(dd);
    saveToStorage(_session_id, dd);
  }
  return { requestData, setRequestData, ...rest, _session_id };
};

export { RequestDataProvider, RequestDataContext, useRequestContext };
